<div class="custom-calendar-header">
    <div class="custom-calendar-controls">
        <button mat-icon-button type="button" class="mat-calendar-previous-button" [disabled]="!previousEnabled()"
            (click)="previousClicked()" [attr.aria-label]="prevButtonLabel">
        </button>

        <button mat-button type="button" class="custom-calendar-period-button" (click)="currentPeriodClicked()"
            [attr.aria-label]="periodButtonLabel" cdkAriaLive="polite">
            {{periodButtonText}}
            <div class="custom-calendar-arrow" [class.mat-calendar-invert]="calendar.currentView != 'month'"></div>
        </button>

        <button mat-icon-button type="button" class="mat-calendar-next-button" [disabled]="!nextEnabled()"
            (click)="nextClicked()" [attr.aria-label]="nextButtonLabel">
        </button>
    </div>
</div>